import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import Breadcrumb from "../../../../../../components/Generic/Breadcrump";
import SubHeader from "../../../../../../components/Generic/SubHeader";
import { PRIVATE_ROUTES } from "../../../../../../constants";
import { ReportGroup } from "../../../../../../models/report.group";
import { Filters } from "../../../../../../models/shipeezi.table";
import { ReportSubGroup } from "../../../../../../util/enums";
import { BookingReport } from "./components/Grids/Bookings";
import { FinancialsReport } from "./components/Grids/Financials";
import { InvoiceReport } from "./components/Grids/Invoices";
import { OrdersReport } from "./components/Grids/Orders";
import { ProductsReport } from "./components/Grids/Products";
import { ShipmentsReport } from "./components/Grids/Shipments";
import { GridDiv, MainDiv, ReportTitle } from "./styled";

export type ReportProps = {
  reportGroup?: ReportGroup;
  name?: string;
  checklistId?: number;
  reportId?: number;
};

export interface HandleGenerateReportProps {
  filtersToReport?: Filters;
}

const ReportMaintenance = () => {
  const { t: translate } = useTranslation();

  const history = useHistory();

  const { state } = useLocation<ReportProps>();
  const { reportGroup, name } = state || {};

  useEffect(() => {
    if (!state) history.push("/");
  }, []);

  const renderReportName = () => {
    if (name) {
      return <ReportTitle>{name}</ReportTitle>;
    }

    return null;
  };

  const chooseGridBySubgroup = () => {
    switch (state?.reportGroup?.subGroup) {
      case ReportSubGroup.Bookings:
        return <BookingReport />;
      case ReportSubGroup.Orders:
        return <OrdersReport />;
      case ReportSubGroup.Shipments:
        return <ShipmentsReport />;
      case ReportSubGroup.Products:
        return <ProductsReport />;
      case ReportSubGroup.Invoices:
        return <InvoiceReport />;
      case ReportSubGroup.Financials:
        return <FinancialsReport />;
      default:
        return <></>;
    }
  };

  return (
    <div>
      <SubHeader showCompanyVersion>
        <Breadcrumb
          items={[
            {
              title: translate("reports"),
              link: {
                url: PRIVATE_ROUTES.ANALYTICS,
              },
            },
            {
              title: reportGroup?.group || "",
            },
            {
              title: reportGroup?.subGroup || "",
              color: "#465869",
            },
          ]}
        />
      </SubHeader>
      <MainDiv>
        {renderReportName()}
        <GridDiv>{chooseGridBySubgroup()}</GridDiv>
      </MainDiv>
    </div>
  );
};

export default ReportMaintenance;
